import service from "@/api/service";
import { GetResponse } from "@/api/common/shop-list/response";
import { GetRequest } from "@/api/common/shop-list/request";

/**
 * 権限店舗取得APIをコールします。
 *
 * @return GetResponse
 */
export async function searchShop(getRequest: GetRequest) {
  const response = await service.post("/common-get-shop-list", getRequest);
  return response.data as GetResponse;
}
